export const POSITION_COLOR: { [key: string]: any } = {
  CREATED_POST: "info",
  PERMANENT_POST: "subtitle2",
  SUPERNUMERARY_POSTS: "success",
  ABOLISHED_POST: "danger",
  DEFAULT: "subtitle2",
};
